<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <div class="card card-custom">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title">
                <h3 class="card-label">
                  <i class="fas fa-filter"></i> Filtros
                </h3>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label class="font-weight-bold">Reporte</label>
                  <b-form-input
                    id="input-1"
                    v-model="filtros.nombreReporte"
                    @keyup.enter="fetchReportes()"
                    placeholder="Buscar por nombre"
                  ></b-form-input>
                </div>
              </div>
            </div>
            <div class="card-footer padding-t-b">
              <div class="col-md-12">
                <a
                  href="#"
                  class="btn btn-primary font-weight-bold mr-2 float-right"
                  @click.prevent="fetchReportes()"
                  ><i class="fa fa-search"></i> Buscar</a
                >
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom">
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">
                <i class=" fa fa-chart-pie"></i> Dimensiones
              </h3>
            </div>
            <div class="card-toolbar">
              <!--<a href="#" class="btn btn-primary font-weight-bold mr-2" @click="initCrearReporte"><i class="la la-plus"></i> Nuevo</a>-->

              <b-dropdown
                right
                variant="primary"
                text="Hover"
                icon="fa fa-plus"
              >
                <template #button-content>
                  <i class="fa fa-plus"></i> Crear
                </template>
                <b-dropdown-item
                  v-for="dimension in dimensiones"
                  :key="dimension.reporteDimensionId"
                  @click="initCrearReporte(dimension)"
                  >{{ dimension.titulo }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-head-custom table-vertical-center table-head-bg table-hover"
              >
                <thead>
                  <tr>
                    <th>Reporte</th>
                    <th>Dimensión</th>
                    <th>Fecha de modificación</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="reporte in reportes"
                    :key="reporte.reporteDimensionConfiguracionId"
                  >
                    <td>
                      {{ reporte.titulo }}
                    </td>
                    <td>{{ reporte.dimensionTitulo }}</td>
                    <td>
                      {{ reporte.modificacionFechaUtc | datetime }}
                    </td>
                    <td class="text-right">
                      <b-dropdown right>
                        <template #button-content>
                          <i class="fas fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item
                          href="#"
                          @click.prevent="gotoReporte(reporte)"
                        >
                          <span class="navi-icon"
                            ><i class="fa fa-pen"></i> Editar</span
                          >
                        </b-dropdown-item>
                        <b-dropdown-item
                          href="#"
                          @click.prevent="previewDimensionConfiguracion(reporte)"
                        >
                          <span class="navi-icon"
                            ><i class="fa fa-eye"></i> Visualizar</span
                          >
                        </b-dropdown-item>
                        <b-dropdown-item
                          href="#"
                          @click.prevent="
                            downloadDimensionConfiguracion(reporte)
                          "
                        >
                          <span class="navi-icon"
                            ><i class="fa fa-file-excel"></i> Exportar</span
                          >
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <b-pagination
              size="md"
              v-model="pagination.page"
              :total-rows="pagination.totalCount"
              :per-page="pagination.pageSize"
              hide-goto-end-buttons
              class="m-0"
            />
          </div>
        </div>
      </div>
    </div>

    <b-modal id="preview-modal" size="xl" :title="titulo" hide-footer>
      <div v-if="ui.hojaPreviewSeleccionada">
        <div class="mb-3">
          <b-dd variant="primary">
            <template #button-content>
              <i class="fa fa-eye"></i> {{ ui.hojaPreviewSeleccionada.titulo }}
            </template>
            <b-dd-item
              v-for="(tabla, indexTabla) in preview.result.tablas"
              :key="indexTabla"
              @click="ui.hojaPreviewSeleccionada = tabla"
              >{{ tabla.titulo }}</b-dd-item
            >
          </b-dd>

          <button
            class="btn btn-secondary"
            id="btn-copy-preview"
            @click="
              copyToClipboard(
                'tbl-' + ui.hojaPreviewSeleccionada.indice,
                'btn-copy-preview'
              )
            "
          >
            <i class="fa fa-copy fa-fw"></i>
          </button>

          <button
            class="btn btn-default"
            v-if="ui.hojaPreviewComprimirCeldas"
            @click="ui.hojaPreviewComprimirCeldas = false"
          >
            <i class="fa fa-compress fa-fw"></i> Comprimido
          </button>

          <button
            class="btn btn-default"
            v-if="!ui.hojaPreviewComprimirCeldas"
            @click="ui.hojaPreviewComprimirCeldas = true"
          >
            <i class="fa fa-expand fa-fw"></i> Expandido
          </button>

          <span class="ml-2"
            ><b>{{ ui.hojaPreviewSeleccionada.filas.length }}</b> fila(s)</span
          >

          <span
            v-b-tooltip.hover
            :title="
              preview.segundosObtenerDatos.toFixed(0) +
                ' seg. de extracción y ' +
                preview.segundosConvertirDatos.toFixed(0) +
                ' seg. de transformación.'
            "
          >
            en {{ preview.segundosTotal.toFixed(0) }} seg.</span
          >
        </div>

        <div class="table-responsive mb-0" style="max-height:500px">
          <table
            class="table table-sm"
            :id="'tbl-' + ui.hojaPreviewSeleccionada.indice"
            :class="[
              ui.hojaPreviewComprimirCeldas ? 'table-cell-ellipsis' : '',
            ]"
          >
            <tr>
              <th
                class="text-center"
                v-for="(columna, index) in ui.hojaPreviewSeleccionada.columnas"
                :key="index"
              >
                <span>{{ columna }}</span>
              </th>
            </tr>
            <tr
              v-for="(fila, index) in ui.hojaPreviewSeleccionada.filas"
              :key="index"
            >
              <td
                class="text-center ellipsis"
                v-for="(valor, indexVal) in fila.valores"
                :key="indexVal"
              >
                <span>
                  {{ valor }}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal id="download-modal" size="md" :title="titulo" hide-footer>
      <div v-if="ui.hasDownloadResult">
        <div class="mb-3">
          <p>
            Reporte generado en {{ download.segundosTotal.toFixed(0) }} segundos
            ({{ download.segundosObtenerDatos.toFixed(0) }} de extracción y
            {{ download.segundosConvertirDatos.toFixed(0) }} de transformación).
          </p>
          <p>
            Utilice el siguiente enlace para descargar o compartir el reporte:
          </p>
          <div class="card p-2 mb-2 border bg-light">
            {{ filesUrl + download.reportUrl }}
          </div>

          <a
            class="btn btn-default"
            :href="`${filesUrl + download.reportUrl}`"
            target="_blank"
            ><i class="fa fa-download fa-fw"></i> Descargar reporte</a
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
.table-cell-ellipsis th {
  min-width: 100px;
}
</style>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

/*intervalos de tiempo de Inactividad*/
import {
  INACTIVE_USER_TIME_THRESHOLD,
  USER_ACTIVITY_THROTTLER_TIME,
} from "@/helpers/constants.js";

export default {
  metaInfo: {
    title: "Reportes - Dimensiones",
  },
  data: () => ({
    moment: moment,
    pagination: { page: 1, paginate: true },
    dimensiones: [],
    reportes: [],
    filtros: {
      nombreReporte: null,
    },
    titulo: "",
    ui: {
      hojaPreviewSeleccionada: null,
      hojaPreviewComprimirCeldas: true,
      clearCopyTimeout: null,
      hasDownloadResult: false,
    },
    preview: {
      result: {
        tablas: [],
      },
      segundosObtenerDatos: null,
      segundosConvertirDatos: null,
      segundosTotal: null,
    },
    download: {
      reportUrl: null,
      segundosObtenerDatos: null,
      segundosConvertirDatos: null,
      segundosTotal: null,
    },
    /*variables de inactividad*/
    isInactive: false,
    userActivityThrottlerTimeout: null,
    userActivityTimeout: null,
  }),
  methods: {
    initCrearReporte: function(dimension) {
      this.$router.push({
        name: "reports-dimension-edit",
        params: { reporteDimensionId: dimension.reporteDimensionId },
      });
    },
    gotoReporte: function(reporte) {
      this.$router.push({
        name: "reports-dimension-edit",
        params: {
          reporteDimensionId: reporte.reporteDimensionId,
          reporteDimensionConfiguracionId:
            reporte.reporteDimensionConfiguracionId,
        },
      });
    },
    fetchConfiguracionModel: async function(reporte) {
      var model = {
        ReporteDimensionConfiguracionId:
          reporte.reporteDimensionConfiguracionId,
      };

      var configModel = null;

      await this.$http
        .get(this.apiRoute("ReportDimension", "GetDimensionConfiguracion"), {
          params: model,
        })
        .then(function(response) {
          if (response.body.error) {
            Swal.fire({
              icon: "error",
              title: "",
              text: response.body.message,
            });
          } else {
            configModel = JSON.parse(response.body.data.configuracionStr);
          }
        });

      return configModel;
    },
    previewDimensionConfiguracion: async function(reporte) {
      this.showLoading();
      var model = await this.fetchConfiguracionModel(reporte);
      if (model == null) {
        this.showLoading(false);
        return;
      }

      this.titulo = reporte.titulo;
      this.ui.hojaPreviewSeleccionada = null;
      this.$http
        .post(
          this.apiRoute("ReportDimension", "GeneratePreviewFromConfiguracion"),
          model
        )
        .then(function(response) {
          if (response.body.error) {
            this.procesarRespuestaGuardarDefecto(response);
          } else {
            this.preview = response.body.data;
            this.ui.hojaPreviewSeleccionada = this.preview.result.tablas[0];
            this.$bvModal.show("preview-modal");
            this.showLoading(false);
          }
        });
    },
    downloadDimensionConfiguracion: async function(reporte) {
      this.showLoading();
      var model = await this.fetchConfiguracionModel(reporte);
      if (model == null) {
        this.showLoading(false);
        return;
      }

      this.titulo = reporte.titulo;
      this.ui.hasDownloadResult = false;
      this.$http
        .post(
          this.apiRoute("ReportDimension", "GenerateReportFromConfiguracion"),
          model
        )
        .then(function(response) {
          if (response.body.error) {
            this.procesarRespuestaGuardarDefecto(response);
          } else {
            this.download = response.body.data;
            this.ui.hasDownloadResult = true;
            this.$bvModal.show("download-modal");
            this.showLoading(false);
          }
        });
    },
    copyToClipboard: async function(containerid, elementReplaceIcon) {
      let el = document.getElementById(containerid);
      var body = document.body,
        range,
        sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
        document.execCommand("copy");
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
        range.execCommand("Copy");
      }

      if (!elementReplaceIcon) {
        await this.sweetAlert("Los datos han sido copiados.");
      } else {
        if (this.ui.clearCopyTimeout) clearTimeout(this.ui.clearCopyTimeout);

        var btnCopiar = document.getElementById(elementReplaceIcon);
        btnCopiar.innerHTML = '<i class="fa fa-check fa-fw"></i>';

        this.ui.clearCopyTimeout = setTimeout(function() {
          var btnCopiar = document.getElementById(elementReplaceIcon);
          btnCopiar.innerHTML = '<i class="fa fa-copy fa-fw"></i>';
        }, 2000);
      }
    },
    fetchDimensiones: function() {
      var model = {};
      this.$http
        .get(this.apiRoute("ReportDimension", "ListDimensiones"), {
          params: model,
        })
        .then(function(response) {
          if (response.body.error) {
            Swal.fire({
              icon: "error",
              title: "",
              text: response.body.message,
            });
          } else {
            this.dimensiones = response.body.data;
          }
        });
    },
    fetchReportes: function() {
      this.showLoading();
      var model = this.cloneObject(this.filtros);
      model.pagination = this.pagination;
      this.$http
        .post(this.apiRoute("ReportDimension", "ListReportes"), model)
        .then(function(response) {
          if (response.body.error) {
            Swal.fire({
              icon: "error",
              title: "",
              text: response.body.message,
            });
          } else {
            this.reportes = response.body.data.items;
            this.pagination = response.body.data.pagination;
          }
          this.showLoading(false);
        });
    },
    /*Metodos para verificar la inactividad del usuario*/
    activateActivityTracker: function() {
      window.addEventListener("mousedown", this.userActivityThrottler);
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      window.addEventListener("resize", this.userActivityThrottler);
      window.addEventListener("touchstart", this.userActivityThrottler); //para dispositivos moviles
    },
    deactivateActivityTracker: function() {
      window.removeEventListener("mousedown", this.userActivityThrottler);
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      window.removeEventListener("resize", this.userActivityThrottler);
      window.removeEventListener("touchstart", this.userActivityThrottler); //para dispositivos moviles
    },
    resetUserActivityTimeout: function() {
      clearTimeout(this.userActivityTimeout);

      this.userActivityTimeout = setTimeout(() => {
        this.userActivityThrottler();
        this.inactiveUserAction();
      }, INACTIVE_USER_TIME_THRESHOLD); /*=> INACTIVE_USER_TIME_THRESHOLD */
    },
    userActivityThrottler: function() {
      if (this.isInactive) {
        this.isInactive = false;
      }

      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();
          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, USER_ACTIVITY_THROTTLER_TIME); /*=> USER_ACTIVITY_THROTTLER_TIME*/
      }
    },
    inactiveUserAction: function() {
      this.isInactive = true;

      Swal.fire({
        icon: "warning",
        title: "Sesión Expirada",
        text: "Su sesión ha expirado. Por favor vuelva a iniciar sesión.",
        confirmButtonText: `Iniciar Sesión`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.deactivateActivityTracker();
          clearTimeout(this.userActivityTimeout);
          clearTimeout(this.userActivityThrottlerTimeout);
          this.$router.push({ name: "login" });
        }
      });
    },
  },
  watch: {
    "pagination.page": function(newValue, oldValue) {
      this.fetchReportes();
    },
  },
  mounted: function() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dimensiones" }]);
    this.fetchDimensiones();
    this.fetchReportes();
    this.activateActivityTracker();
  },
};
</script>
